import CheckoutState from '../interfaces/state';
import { Timeframe } from '../../interfaces/customer-data';

const checkoutInitialState: CheckoutState = {
  customerData: {
    contact: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
    },
    pickupAddress: {
      street: '',
      zipCode: '',
      shippingAdditionalName: ''
    },
    deliveryAddress: {
      street: '',
      zipCode: '',
      shippingAdditionalName: ''
    },
    pickupTime: {
      date: null,
      timeframe: Timeframe['MORNING'],
    },
    deliveryTime: {
      date: null,
      timeframe: Timeframe['MORNING'],
    },
    flags: {
      acceptTerms: false,
      joinClub: false,
      acceptWithdrawal: false,
    },
  },
  customerShippingData: {
    contact: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
    },
    address: {
      street: '',
      zipCode: '',
      city: '',
      country: 'Germany',
      shippingAdditionalName: ''
    },
    flags: {
      acceptTerms: false,
      joinClub: false,
      acceptWithdrawal: false,
    },
  },
};

export default checkoutInitialState;
